module.exports = __webpack_public_path__ + "media/images/sp/articles/popular_contents_plans-7e2e492341a049d9c27104dfa61bd4e3.webp";